import PropTypes from "prop-types";

import RateFields from "./RateFields";

const SetCarPrice = ({ rate, setRate, t }) => (
    <div>
        <p className="text-md font-medium mb-4">{t("rates.setPrice")}</p>
        <RateFields value={rate} onChange={setRate} t={t} />
        {/* <div className="flex justify-between items-center mt-6 border-t border-gray-200">
            <div>
                <p className="text-sm font-medium">{t("rates.calenderDay")}</p>
                <p className="text-xs text-gray-600 mt-1">{t("rates.calenderDayDescription")}</p>
            </div>
            <Switch
                checked={calenderDay}
                onChange={setCalenderDay}
                checkedChildren={t("rates.switchOn")}
                unCheckedChildren={t("rates.switchOff")}
            />
        </div> */}
    </div>
);

SetCarPrice.propTypes = {
    rate: PropTypes.object.isRequired,
    setRate: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default SetCarPrice;
